import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { findDOMNode } from 'react-dom';
import $ from "jquery";

import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Switch from '@material-ui/core/Switch';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import { validateForm } from '../formValidator';
import ModalBox from '../Modals/ModalBox';
import { Editor } from '../Editor';

import { API } from '../../../ws/constants';

import './style.css';
var moment = require('moment');

export class AddEditNote extends Component {
    date = moment();
    state = {
        noteId: this.props.noteId || "New"
        , noteCat: this.props.catId || 1
        , noteName: "Nova Nota"
        , noteText: ""
        , isActive: 1
        , categories: null
        , editable: false
    };

    componentDidMount() {
        const { noteId } = this.state;
        const { isAdmin, loginData } = this.props;
        const newState = {
            editable: Boolean(isAdmin || (loginData.profile.Notepad && loginData.profile.Notepad.permission === 1)),
        };
        const fetches = [
            fetch(API + "getnotescategories")
        ];
        
        if(noteId !== "New"){
            fetches.push(fetch(API + "getnotes&getbyid=" + noteId));
        }

        Promise.all(fetches)
        .then(responses => Promise.all(responses.map(r => r.json())))
        .then(result => {
            if(noteId !== "New"){
                const noteData = result[1].data;
                
                newState.noteData = noteData;
                newState.noteCat = noteData.CategoryId || this.state.noteCat;
                newState.noteName = noteData.Name || this.state.noteName;
                newState.noteText = noteData.Note || this.state.noteText;
                newState.isActive = noteData.IsActive;

                fetch(API + "setseennote", {
                    method: 'POST'
                    ,headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    }
                    ,body: JSON.stringify({
                        noteid: noteId,
                        categoryid: noteData.CategoryId,
                        cur_userid: this.props.loginData.Id
                    })
                })
                .then(response => response.json())
                .then(result => {
                    if(result.shortmsg === "OK"){
                        this.props.getUnseenNotes();
                    }
                });
            }
                
            newState.categories = result[0].data;
            
            this.setState(newState);
        });
    }

    componentDidUpdate(prevProps, prevState){
        if(prevProps.noteId !== this.props.noteId){
            const newState = {
                noteId: this.props.noteId || "New"
                , noteCat: this.props.catId || 1
                , noteName: "Nova Nota"
                , noteText: ""
                , isActive: 1
            }
            this.setState(newState);
        }
    }

    handleMessageChange = (noteText) => this.setState({ noteText });
    handleFieldChange = (e) => this.setState({ [e.target.id]: e.target.value });
    handleSelectChange = (e) => this.setState({ [e.target.name]: e.target.value });
    handleToggle = (e, value) => this.setState({ [e.target.id]: value ? "1" : "0" });

    handleSave = () => {
        if(validateForm($(findDOMNode(this.refs.editForm)), { validateHiddenFields: false, showErrorMessage: true, dumbValidations: false })){
            this.setState({loading:true});
            const sendParams = {
                noteid:this.state.noteId
                ,categoryid:this.state.noteCat
                ,name:this.state.noteName || '&nbsp;'
                ,note:this.state.noteText
                ,isactive:this.state.isActive
                ,cur_userid:this.props.loginData.Id
                ,cur_username:this.props.loginData.Name
            }

            fetch(API + "savenote", {
                method: 'POST'
                ,headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
                ,body: JSON.stringify(sendParams)
            })
            .then(response => response.json())
            .then(result => {
                this.setState({ 
                    noteId: result.data !== "" && result.data.length ? result.data[0] : "New", 
                    returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", 
                    returnText: result.message, 
                    openModal: true, 
                    loading: false,
                    modalCallBack: () => this.setState({openModal: false })
                });
            });
        }
    }

    goBack = () => {
        this.props.onBackClick && this.props.onBackClick(this.state.noteCat);
    }

    handleDelete = (e) => {
        if(window.confirm("Tem a certeza que quer apagar esta nota?")){
            const onlyInactivate = this.props.isAdmin || this.props.loginData.profile.Notepad.isActive ? "" : "&inactivate=true";
            this.setState({ loading:true });
            fetch(API + 'deletenote&noteid=' + this.state.noteId + onlyInactivate + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({ 
                    returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", 
                    returnText: result.message, 
                    openModal: true, 
                    loading:false,
                    modalCallBack: this.goBack
                });
            });

        }
    }

    renderCategoryOptions = () => {
        const categories = this.state.categories;
        if(categories===null)
            return;
        
        const items = [<MenuItem value="0" key="0" disabled={true}>Escolha a categoria</MenuItem>];
        for (let i=0,n=categories.length;i<n;i++) {
            items.push(<MenuItem value={categories[i].Id}
                                 key={categories[i].Id}>{ReactHtmlParser(categories[i].Icon)}&nbsp;{categories[i].Name}</MenuItem>);
        }
        items.push(<MenuItem value="999" key="999"><i className="fa fa-globe-europe"></i>&nbsp;Outros</MenuItem>);
        return items;
    }

    render() {
        const { isAdmin, loginData, } = this.props;
        const { editable, noteId, noteCat, noteName, noteText, isActive } = this.state;
        const loadingClass = this.state.loading ? " ajaxLoading" : ""
            , optsCategories = this.renderCategoryOptions();

        return (
            <div id="addEditNotePage" className={"addEditPage" + loadingClass}>
                <div ref="editForm" className="form">
                    <div className="row">
                        <div className="col-12">
                            <h1 className="pageHeader"><i className="fa fa-address-book"></i> {noteName}
                                { (isAdmin || loginData.profile.Notepad.isActive) && 
                                    <span className="float-right">
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    id="isActive"
                                                    checked={!!+isActive}
                                                    disabled={!(isAdmin || (loginData.profile.Notepad.isActive.permission === 1 && editable))}
                                                    onChange={this.handleToggle}
                                                    color="primary"/>
                                            }
                                            label="Ativo"/>
                                    </span>
                                }
                            </h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 buttonsHolder">
                            <button onClick={this.goBack} className="actionButton">Voltar</button>
                            { (isAdmin || loginData.profile.Notepad.DEL) && noteId !== "New" && <button onClick={this.handleDelete} className="actionButton dangerText">Apagar Nota</button>}
                            { editable && <button onClick={this.handleSave} className="actionButton float-right"><i className='fa fa-check'></i> Salvar</button>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-8 fieldHolder">
                            <TextField fullWidth
                                        id="noteName"
                                        value={noteName}
                                        onChange={this.handleFieldChange}
                                        label="Nome"
                                        placeholder="Introduza o Nome da Nota"
                                        disabled={!editable} />
                        </div>
                        <div className="col-md-4 fieldHolder required selectField">
                            { this.state.categories && 
                                <FormControl fullWidth={true}>
                                    <InputLabel htmlFor="noteCat">Lista de Categorias</InputLabel>
                                    <Select id="noteCat"
                                            name="noteCat"
                                            value={noteCat}
                                            onChange={this.handleSelectChange}
                                            disabled={!editable}
                                            data-empty-error-message="Este campo não pode estar vazio">
                                    {optsCategories}
                                    </Select>
                                </FormControl>
                            }
                        </div>
                    </div>                    
                    <div className="row">
                        <div className={"col-12 fieldHolder editorHolder"}>
                            <InputLabel htmlFor="message">A minha nota:</InputLabel>
                            <Editor
                                id="message"
                                value={noteText}
                                onChange={this.handleMessageChange}
                                disabled={!this.state.editable}
                                placeholder="Introduza a Mensagem"
                                height="45vh"
                                options={{
                                    mode: 'balloon'
                                }}
                            />
                        </div>
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.state.modalCallBack} noOverlay={true} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}
